import { render, staticRenderFns } from "./detail1.vue?vue&type=template&id=042c6c6d&scoped=true&"
import script from "./detail1.vue?vue&type=script&lang=js&"
export * from "./detail1.vue?vue&type=script&lang=js&"
import style0 from "./detail1.vue?vue&type=style&index=0&id=042c6c6d&lang=scss&scoped=true&"
import style1 from "./detail1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c6c6d",
  null
  
)

export default component.exports